<span
  class="get-code"
  *ngIf="timeout2 === 91 && !code"
  (click)="getCode()"
  style="
    text-decoration: underline;
    color: var(--primary-color);
    cursor: pointer;
  "
  >点击获取验证码
</span>
<span
  class="get-code"
  *ngIf="timeout2 !== 0 && timeout2 !== 91 && !code"
  style="color: #909090; text-decoration-line: underline; cursor: unset"
>
  查询正在进行中…({{ timeout2 }})秒
</span>
<span
  class="get-code"
  (click)="getCode()"
  *ngIf="timeout2 === 0 && !code"
  style="
    display: flex;
    align-items: center;
    text-decoration: underline;
    color: var(--primary-color);
    cursor: pointer;
  "
>
  <mat-icon style="color: var(--primary-color); margin-right: 5px"
    >refresh</mat-icon
  >重试
</span>
<span class="get-code" *ngIf="code">{{ code }}</span>
